module.exports = __webpack_public_path__ + "img/et.9d61eea3.svg";